function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1081.000000, -9.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1079.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.7759433,14.9204968 L13.7832194,15.916428 C13.6016599,16.0926791 13.0835315,16.2062839 13.0633634,16.2062839 C9.91528447,16.2338888 6.88299572,14.9937762 4.65118119,12.7619344 C2.41300636,10.5258797 1.16877859,7.47962004 1.20791893,4.31795074 C1.20791893,4.31476516 1.32152647,3.81255117 1.4945947,3.63525088 L2.49794632,2.63931962 C2.85681427,2.27406419 3.56394966,2.10418426 4.05236125,2.27194408 L4.26258834,2.33883329 C4.74887982,2.50765044 5.2627598,3.04596868 5.39654364,3.54604082 L5.90088317,5.38286413 C6.03360152,5.88402351 5.85098196,6.59537192 5.48787109,6.9595673 L4.82427933,7.62527917 C5.4772434,10.0418143 7.37247823,11.9424038 9.78803489,12.5941991 L10.4590742,11.9306073 C10.8221823,11.5632318 11.534618,11.3806312 12.0325972,11.5165352 L13.8736607,12.0176946 C14.3726728,12.1557213 14.9088682,12.6653584 15.0713006,13.1580102 L15.144561,13.3703601 C15.3059469,13.8566516 15.144561,14.5563394 14.7761254,14.9205076 L14.7759433,14.9204968 Z",
  transform: "translate(8.207023, 9.206896) rotate(11.000000) translate(-8.207023, -9.206896) "
}))))));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e052beeb.svg";
export { ForwardRef as ReactComponent };